import React, { memo } from 'react';
import {
	Accordion as MuiAccordion,
	AccordionDetails as MuiAccordionDetails,
	AccordionSummary as MuiAccordionSummary,
	Typography
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { styled } from '@mui/material/styles';

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} {...props} />)(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	'&:not(:last-child)': {
		borderBottom: 0
	},
	'&:before': {
		display: 'none'
	}
}));

const AccordionSummary = styled((props) => <MuiAccordionSummary expandIcon={<ArrowForwardIcon />} {...props} />)(
	({ theme }) => ({
		backgroundColor: theme.palette.primary.light,
		color: theme.palette.primary.contrastText,
		flexDirection: 'row-reverse',
		'& .MuiAccordionSummary-expandIconWrapper': {
			color: theme.palette.primary.contrastText,
			'&.Mui-expanded': {
				transform: 'rotate(90deg)'
			}
		},
		'& .MuiAccordionSummary-content': {
			marginLeft: theme.spacing(1)
		}
	})
);

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: '1px solid rgba(0, 0, 0, .125)'
}));


const CustomAccordion = ({ title, children, summaryProps, ...rest }) => {
	return (
		<Accordion {...rest}>
			<AccordionSummary {...summaryProps}>
				<Typography>{title}</Typography>
			</AccordionSummary>
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
};

export default memo(CustomAccordion);